

// // // // export default HeroSlider;
// // // import React, { useEffect, useState } from "react";
// // // import Slider from "react-slick";

// // // const desktopImages = [
// // //   "/images/slider2.png",
// // //   "/images/slider3.png",
// // //   "/images/slider4.png",
// // // ];

// // // const mobileImages = [
 
// // //   "/images/9.png",
  
// // // ];

// // // const HeroSlider = () => {
// // //   const [isMobile, setIsMobile] = useState(false);

// // //   useEffect(() => {
// // //     const checkScreenSize = () => {
// // //       setIsMobile(window.innerWidth <= 768);
// // //     };

// // //     checkScreenSize();
// // //     window.addEventListener("resize", checkScreenSize);
// // //     return () => window.removeEventListener("resize", checkScreenSize);
// // //   }, []);

// // //   const images = isMobile ? mobileImages : desktopImages;

// // //   const settings = {
// // //     dots: true,
// // //     infinite: true,
// // //     speed: 1800,
// // //     slidesToShow: 1,
// // //     slidesToScroll: 1,
// // //     autoplay: true,
// // //     autoplaySpeed: 3000,
// // //     arrows: false,
// // //     fade: true,
// // //   };

// // //   return (
// // //     <div className="relative w-full overflow-hidden m-0 p-0">
// // //       <Slider {...settings}>
// // //         {images.map((src, index) => (
// // //           <div key={index} className="w-full h-auto flex justify-center items-center">
// // //             <img
// // //               src={src}
// // //               alt={`slide-${index}`}
// // //               className={`block w-full ${
// // //                 isMobile ? "object-contain" : "object-cover"
// // //               }`}
// // //               style={{
// // //                 maxHeight: isMobile ? "75vh" : "90vh",
// // //                 transform: isMobile ? "scale(0.99)" : "none",
// // //               }}
// // //             />
// // //           </div>
// // //         ))}
// // //       </Slider>
// // //     </div>
// // //   );
// // // };

// // // export default HeroSlider;
// // import React, { useEffect, useState } from "react";
// // import Slider from "react-slick";

// // const desktopImages = [
// //   "/images/slider2.png",
// //   "/images/slider3.png",
// //   "/images/slider4.png",
// // ];

// // const mobileImages = [
// //   "/images/99.webp",
// //   "/images/98.webp",
// // ];

// // const HeroSlider = () => {
// //   const [isMobile, setIsMobile] = useState(false);

// //   useEffect(() => {
// //     const checkScreenSize = () => {
// //       setIsMobile(window.innerWidth <= 768);
// //     };

// //     checkScreenSize();
// //     window.addEventListener("resize", checkScreenSize);
// //     return () => window.removeEventListener("resize", checkScreenSize);
// //   }, []);

// //   const images = isMobile ? mobileImages : desktopImages;

// //   const settings = {
// //     dots: true,
// //     infinite: true,
// //     speed: 1800,
// //     slidesToShow: 1,
// //     slidesToScroll: 1,
// //     autoplay: true,
// //     autoplaySpeed: 3000,
// //     arrows: false,
// //     fade: true,
// //   };

// //   return (
// //     <div
// //       className={`relative w-full overflow-hidden m-0 p-1 ${
// //         isMobile ? "aspect-[3/4]" : "aspect-[2/1]"
// //       }`}
// //     >
// //       <Slider {...settings}>
// //         {images.map((src, index) => (
// //           <div key={index} className="w-full h-full flex justify-center items-center">
// //             <img
// //               src={src}
// //               alt={`slide-${index}`}
// //               loading="lazy"
// //               width={isMobile ? 720 : 1920}
// //               height={isMobile ? 900 : 960}
// //               className="w-full h-full object-cover"
// //             />
// //           </div>
// //         ))}
// //       </Slider>
// //     </div>
// //   );
// // };

// // export default HeroSlider;
// import React, { useEffect, useState } from "react";
// import Slider from "react-slick";

// const desktopImages = [
//   "/images/slider2.png",
//   "/images/slider3.png",
//   "/images/slider4.png",
// ];

// const mobileImages = [
//   "/images/99.webp",
 
// ];

// const HeroSlider = () => {
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     const checkScreenSize = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };

//     checkScreenSize();
//     window.addEventListener("resize", checkScreenSize);

//     return () => window.removeEventListener("resize", checkScreenSize);
//   }, []);

//   const images = isMobile ? mobileImages : desktopImages;

//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 1800,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     arrows: false,
//     fade: true,
//   };

//   return (
//     <div
//       className="w-full mx-auto relative overflow-hidden"
//       style={{ aspectRatio: isMobile ? "4 / 7" : "2 / 1" }}
//     >
//       <Slider {...settings} className="w-full h-full">
//         {images.map((src, index) => (
//           <div
//             key={index}
//             className={`w-full ${
//               isMobile ? "h-[100svh]" : "aspect-[2/1]"
//             }`}
//           >
//             <img
//               src={src}
//               alt={`slide-${index}`}
//               loading={index === 0 ? "eager" : "lazy"}
//               className={`w-full h-full ${
//                 isMobile
//                   ? "object-contain object-center bg-black"
//                   : "object-cover object-center"
//               }`}
//             />
//           </div>
//         ))}
//       </Slider>
//     </div>
//   );
// };

// export default HeroSlider;

import React, { useEffect, useState } from "react";
import Slider from "react-slick";

const desktopImages = [
  "/images/slider2.png",
  "/images/slider3.png",
  "/images/slider4.png",
];

const mobileImages = ["/images/99.webp"];

const HeroSlider = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const images = isMobile ? mobileImages : desktopImages;

  const settings = {
    dots: false,
    infinite: true,
    speed: 1800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    fade: true,
  };

  return (
    <section className="w-full h-[100svh] overflow-hidden">
      <Slider {...settings} className="w-full h-full">
        {images.map((src, index) => (
          <div
            key={index}
            className={isMobile ? "w-full h-[100svh]" : "w-full aspect-[2/1]"}
          >
            <img
              src={src}
              alt={`slide-${index}`}
              loading={index === 0 ? "eager" : "lazy"}
              className="w-full h-full object-cover object-center"
            />
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default HeroSlider;